import { Injectable } from '@angular/core';
import * as Stigg from '@stigg/js-client-sdk';
import { AuthService } from '@anecdotes/auth-core';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { WindowHelperService } from '@anecdotes/utils';

@Injectable()
export class StiggClientWrapper {
  private isInitialized: boolean;
  private stiggClient: Stigg.StiggClient;
  private updates$: Observable<void>;
  private allEntitlements$ = new BehaviorSubject<Stigg.Entitlement[]>(null);

  constructor(
    private authService: AuthService,
    private windowHelper: WindowHelperService,
    private stiggClientFactory: (config: Stigg.ClientConfiguration) => Stigg.StiggClient,
  ) {}

  getAllEntitlements(): Observable<Stigg.Entitlement[]> {
    return this.allEntitlements$.pipe(filter(Boolean));
  }

  async initAsync(): Promise<void> {
    if (!this.isInitialized && (await this.authService.isAuthenticatedAsync())) {
      const stigConfig = this.windowHelper.getWindow()['__AnPlatformConfiguration__'].stigg;
      const user = await this.authService.getUserAsync();
      this.stiggClient = this.stiggClientFactory({
        apiKey: stigConfig.apiKey,
        customerId: user.customer_id ?? 'c_auditors', // temp fix for auditor portal
      });
      await this.stiggClient.waitForInitialization();
      this.updates$ = new Observable((subscriber) =>
        this.stiggClient.addListener('entitlementsUpdated', () => subscriber.next()),
      );
      this.allEntitlements$.next(await this.getAllEntitlementsAsync());
      this.updates$.subscribe(async () => this.allEntitlements$.next(await this.getAllEntitlementsAsync()));
    }

    this.isInitialized = true;
  }

  async reloadEntitlements(): Promise<void> {
    await this.stiggClient.refresh();
    this.allEntitlements$.next(await this.getAllEntitlementsAsync());
  }
  
  private async getAllEntitlementsAsync(): Promise<Stigg.Entitlement[]> {
    return await this.stiggClient.getEntitlements();
  }
}
